import 'bootstrap-sweetalert/dist/sweetalert.css';
import 'bootstrap/dist/css/bootstrap.css';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import 'perfect-scrollbar-react/dist/style.min.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Route, Switch} from 'react-router';
import {HashRouter} from 'react-router-dom';
import './commonMixins.scss';
import {CertificateListPage} from './components/CertificatePages/CertificateListPage';
import {LibraryListPage} from './components/LibraryRequest/LibraryListPage';
import {Home} from './components/Home';
import {LoginPage} from './components/LoginPage';
import {CreateModule} from './components/Modules/CreateModule';
import {MCQPage} from './components/Modules/MCQPage';
import {ModuleDetailsPage} from './components/Modules/ModuleDetailsPage';
import {ModuleListPage} from './components/Modules/ModuleListPage';
import {UpdateModule} from './components/Modules/UpdateModule';
import {UpdatePassword} from './components/Profile/UpdatePassword';
import {UserProfilePage} from './components/Profile/UserProfilePage';
import {UserFeedback} from './components/Profile/UserFeedback';
import {AuthRoute} from './components/reusableComponents/AuthRoute';
import {UserModuleListPage} from './components/UserModules/UserModuleListPage';
import {CreateUser} from './components/Users/CreateUser';
import {MultipleUserCreation} from './components/Users/CreateMultipleUser';
import {UpdateUser} from './components/Users/UpdateUser';
import {UserDetailsPage} from './components/Users/UserDetailsPage';
import {UserListPage} from './components/Users/UserListPage';
import {DashboardGraphPage} from './components/Dashboard/dashboard';
import './constants/commonVars.scss';
import './generals.scss';
import './mediaQueries.scss';
import registerServiceWorker from './registerServiceWorker';
import {store} from './store';
import {OrgListPage} from './components/Organization/OrgListPage';
import { UpdateOrg } from './components/Organization/UpdateOrg';
import {CreateOrg} from './components/Organization/CreateOrg';
import {OrgDetailsPage} from './components/Organization/OrgDetailsPage';
import './responsiveQueriesNew.scss';

require('react-select/dist/react-select.css');
require('font-awesome/css/font-awesome.min.css');

ReactDOM.render(
    <Provider store={store as any}>
        <MuiThemeProvider>
            <HashRouter>
                <Switch>
                    <Route exact path="/" component={LoginPage}/>
                    <Route exact path="/login/:token" component={LoginPage}/>
                    <AuthRoute path="/home" component={Home}/>
                    <AuthRoute path="/user-profile/:id" component={UserProfilePage}/>
                    <AuthRoute path="/user-module/list" component={UserModuleListPage}/>
                    <AuthRoute path="/certificates/:id" component={CertificateListPage}/>
                    <AuthRoute path="/libraryrequest" component={LibraryListPage}/>
                    <AuthRoute path="/update-password/:email" component={UpdatePassword}/>
                    <AuthRoute path="/user-feedback/:id" component={UserFeedback}/>
                    <AuthRoute path="/training/create" component={CreateModule}/>
                    <AuthRoute path="/training/list" component={ModuleListPage}/>
                    <AuthRoute path="/training/edit/:id" component={UpdateModule}/>
                    <AuthRoute path="/training/start-test/:moduleName/:id" component={MCQPage}/>
                    <AuthRoute path="/training/:id" component={ModuleDetailsPage}/>
                    <AuthRoute path="/users/list" component={UserListPage}/>
                    <AuthRoute path="/users/modules" component={UserListPage}/>
                    <AuthRoute path="/users/create" component={CreateUser}/>
                    <AuthRoute path="/users/createMultiple" component={MultipleUserCreation}/>
                    <AuthRoute path="/users/edit/:id" component={UpdateUser}/>
                    <AuthRoute path="/users/:id" component={UserDetailsPage}/>
                    <AuthRoute path="/dashboard" component={DashboardGraphPage}/>
                    <AuthRoute path="/org/list" component={OrgListPage}/>
                    <AuthRoute path="/org/create" component={CreateOrg}/>
                    <AuthRoute path="/org/edit/:id" component={UpdateOrg}/>
                    <AuthRoute path="/org/:id" component={OrgDetailsPage}/>
                </Switch>
            </HashRouter>
        </MuiThemeProvider>
    </Provider>,
    document.getElementById('training-module') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx